import { Project } from '../types';

const project: Project = {
  slug: 'suspended-horizon',
  accessPin: '4819',
  qrTickets: ['S3H8L2'],
  info: {
    id: 3,
    title: 'Suspended Horizon',
    category: {
      'en-US': 'Residential',
      'es-MX': 'Residencial',
    },
    year: 2012,
    location: 'La Paz, Baja California Sur',
    floor: '3 Floors',
    building: '67.88aZA-',
    cover: '/images/Cover1.webp',
    description: {
      'en-US':
        "Suspended Horizon is a bold architectural statement where sharp geometry meets the serenity of nature. Elevated volumes, expansive glazing, and dynamic rooflines create a sense of weightlessness, blurring the boundary between indoor elegance and the surrounding landscape. It's not just a home - it's a living sculpture anchored to the horizon.",
      'es-MX':
        'Suspended Horizon es una declaracion arquitectonica audaz donde la geometria precisa se encuentra con la serenidad del paisaje. Volumenes elevados, grandes ventanales y cubiertas dinamicas generan una sensacion de ligereza y difuminan el limite entre interior y exterior. No es solo una casa, es una escultura habitable anclada al horizonte.',
    },
  },
  assets: {
    images: [
      { file: '1.1', ext: 'webp' },
      { file: '1.2', ext: 'webp' },
      { file: '1.3', ext: 'webp' },
    ],
    videos: [],
    panos: [],
  },
};

export default project;
